export const LowImpactAlertTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">SolarEdge
                    Monitoring Portal</span> at <a
                    href="https://monitoring.solaredge.com/solaredge-web/p/login"
                    target="_blank"
                    rel="noreferrer"
                >https://monitoring.solaredge.com/solaredge-web/p/login</a>.
            </li>
            <li>
                <span className="font-semibold">Locate</span> the associated warranty holder in the
                <span className="font-semibold"> 'Sites' list</span>.
            </li>
            <li>
                <span className="font-semibold">Navigate</span> to the
                <span className="font-semibold"> 'Alerts' tab</span>.
            </li>
            <li>
                <span className="font-semibold">Click</span> on the <span className="font-semibold">hyperlinked
                    Alert type</span> in the
                <span className="font-semibold">'Alert Type' column</span>.
            </li>
            <li>
                <span className="font-semibold">Review</span> the <span className="font-semibold">troubleshooting
                    tips</span> in the alert details pop-up.
            </li>
            <li>
                <span className="font-semibold">Contact</span>
                <span className="font-semibold">SolarEdge support</span> for additional assistance if needed.
            </li>
        </ul>
    </div>
